"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagMK = function FlagMK(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-12.42-13.41h0L-115.32-122h-70.62a7,7,0,0,0-4.46,1.71L-17.7-7.15a35.11,35.11,0,0,1,5.28-6.26Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-23.15,15.8a36.07,36.07,0,0,1-.36-3.62,36.07,36.07,0,0,1,.36-3.62L-193-9V33.37Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.31-22.58a35.46,35.46,0,0,1,5.49-.55,35.46,35.46,0,0,1,5.49.55L33-122H-9.39Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M41.3-7.15,214-120.29a7,7,0,0,0-4.46-1.71H138.92L36-13.4h0A35.53,35.53,0,0,1,41.3-7.15Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M36,37.76h0l102.89,108.6h70.62a7,7,0,0,0,4.46-1.71L41.3,31.51A34.76,34.76,0,0,1,36,37.76Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M46.75,8.57h0a36.07,36.07,0,0,1,.36,3.62,36.07,36.07,0,0,1-.36,3.62L216.6,33.37V-9Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.29,46.94a35.46,35.46,0,0,1-5.49.55,35.46,35.46,0,0,1-5.49-.55l-15.7,99.42H33Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-17.7,31.51-190.4,144.65a7,7,0,0,0,4.46,1.71h70.62L-12.43,37.76h0a34.36,34.36,0,0,1-5.28-6.25Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M40.05,12.18A28.25,28.25,0,1,1,11.8-16.07,28.25,28.25,0,0,1,40.05,12.18Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagMK;
exports["default"] = _default;